import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { LucideIcon, Plus } from 'lucide-react';
import './shared.css';

export interface SectionTitleProps {
    icon: LucideIcon;
    title: string;
    /** Shown as "(n)" after the title when given and above zero */
    count?: number;
    /** 'section' for the work order's sections, 'sub' for groups inside Dokumentation */
    level?: 'section' | 'sub';
    /** Right-aligned "+ <label>" button */
    onAdd?: () => void;
    addLabel?: string;
    /** Shows a spinner in place of the add button's plus and disables it */
    adding?: boolean;
    /** Right-aligned slot, e.g. the autosave indicator or a toggle */
    extra?: React.ReactNode;
}

/**
 * A work-order section heading: a muted icon, the bold black title and an
 * optional count, with an optional slot and add button on the right.
 */
export const SectionTitle: React.FC<SectionTitleProps> = ({
    icon: Icon,
    title,
    count,
    level = 'section',
    onAdd,
    addLabel,
    adding,
    extra
}) => {
    const Heading = level === 'section' ? 'h3' : 'h4';
    const iconSize = level === 'section' ? 16 : 14;
    return (
        <div className="wo-section-title-row">
            <Heading className={level === 'section' ? 'wo-section-title' : 'wo-section-title wo-section-title--sub'}>
                <Icon size={iconSize} className="wo-section-title__icon" aria-hidden="true" />
                <span>{title}</span>
                {count !== undefined && count > 0 && <span className="wo-section-title__count">({count})</span>}
            </Heading>
            {(extra || onAdd) && (
                <div className="wo-section-title-row__actions">
                    {extra}
                    {onAdd && (
                        <Button variant="outline-primary" size="sm" className="wo-add-btn" onClick={onAdd} disabled={adding}>
                            {adding ? <Spinner animation="border" size="sm" /> : <Plus size={14} aria-hidden="true" />}
                            {addLabel}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

export default SectionTitle;
